/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 PRO React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 PRO React layouts
 import Analytics from "layouts/dashboards/analytics";
 import SignInBasic from "layouts/authentication/sign-in/basic"; 
 import Office from "layouts/masters/office";
 import ItemCategory from "layouts/masters/itemcategory";
 import Item from "layouts/masters/item";
 import Unit from "layouts/masters/unit"; 
 import Vendor from "layouts/masters/vendor";
 import ItemDemand from "layouts/stock/ItemDemand";
 import ItemReceipt from "layouts/stock/ItemReceipt";
 import ItemDistribution from "layouts/stock/ItemDistribution";
 import UpdatePassword from "layouts/masters/updatepassword";
 import ItemReceiptReport from "layouts/reports/itemreceiptreport";
 import ItemDistributionReport from "layouts/reports/itemdistributionreport"; 
 import ItemDemandReport from "layouts/reports/itemdemandreport";
// Material Dashboard 2 PRO React components
// import MDAvatar from "components/MDAvatar";

// @mui icons
import Icon from "@mui/material/Icon";

// Images
// import profilePicture from "assets/images/team-3.jpg";
// const  userRole = JSON.parse(sessionStorage.getItem('userData')).userRole;

const routes = [
  {
    type: "collapse",
    name: "Dashboards",
    key: "dashboards",
    icon: <Icon fontSize="medium">dashboard</Icon>,
    route: "/dashboards/analytics",    
    component: <Analytics />,      
    noCollapse: true
  },  
  { type: "divider", key: "divider-1" },
  { 
    type: "collapse",
    name: "Stock",
    key: "stock",
    icon: <Icon fontSize="medium">apps</Icon>,
    collapse: [     
      {
        name: "Item Demand",
        key: "itemdemand",
        route: "/stock/itemdemand",
        component: <ItemDemand />,
      }, 
      {
        name: "Item Receipt",
        key: "itemreceipt",
        route: "/stock/itemreceipt",
        component: <ItemReceipt />,
      }, 
      {
        name: "Item Distribution",
        key: "itemdistribution",
        route: "/stock/itemdistribution",
        component: <ItemDistribution />,
      }, 
    ]      
  },
  { type: "divider", key: "divider-1" },
  { 
    type: "collapse",
    name: "Reports",
    key: "report",
    icon: <Icon fontSize="medium">report</Icon>,
    collapse: [     
      {
        name: "Item Demand Report",
        key: "itemdemandreport",
        route: "/report/itemdemandreport",
        component: <ItemDemandReport />,
      }, 
      {
        name: "Item Receipt Report",
        key: "itemreceiptreport",
        route: "/report/itemreceiptreport",
        component: <ItemReceiptReport />,
      }, 
      {
        name: "Item Distribution Report",
        key: "itemdistributionreport",
        route: "/report/itemdistributionreport",
        component: <ItemDistributionReport />,
      }, 
    ]        
  },
  { type: "divider", key: "divider-2" },
  {
    type: "collapse",
    name: "Settings",
    key: "masters",
    icon: <Icon fontSize="medium">apps</Icon>,
    collapse: [          
      {
        name: "Office",
        key: "office",
        route: "/masters/office",
        component: <Office />,
      }, 
      {
        name: "Item Category",
        key: "itemcategory",
        route: "/masters/itemcategory",
        component: <ItemCategory />,
      }, 
      {
        name: "Item",
        key: "item",
        route: "/masters/item",
        component: <Item />,
      }, 
      {
        name: "Unit",
        key: "unit",
        route: "/masters/unit",
        component: <Unit />,
      }, 
      {
        name: "Vendor",
        key: "vendor",
        route: "/masters/vendor",
        component: <Vendor />,
      },            
    ],
  },
  { type: "divider", key: "divider-3" },    
  {
    type: "collapse",
    name: "Change Password",
    key: "password",
    icon: <Icon fontSize="medium">password</Icon>,
    route: "/masters/updatepassword",
    component: <UpdatePassword />,         
    noCollapse: true
  },   
  {
    type: "collapse",
    name: "Logout",
    key: "logout",
    icon: <Icon fontSize="medium">logout</Icon>,
    route: "/authentication/sign-in/basic",
    component: <SignInBasic />,         
    noCollapse: true
  },   
];

export default routes;
